export enum FromProviderType {
  IMPERIA = 'IMPERIA',
  SUITEEDGE = 'SUITEEDGE',
}
